import React, { useContext } from 'react'
import { FormValueObject } from '#src/components/Path/Form'
import {
  PathFlowFragment,
  PathFlowPageFragment,
  PathValidationErrorFragment
} from '#src/generated/graphql'

export type PathContextType = {
  // The entire path flow object
  pathFlow: PathFlowFragment
  // Data related to the individual path flow page
  pathFlowPage: PathFlowPageFragment
  // The errors returned from the submission of the question mutations
  pageErrors: PathValidationErrorFragment[]
  // Is the submit button hidden from criteria in the form component
  isSubmitButtonHidden: boolean
  // Is the back button hidden (first page, previous page is interstitial)
  isBackButtonHidden: boolean
  // Are the mutations submitting, the PathFlowPage mutation submitting or the PathFlow query loading
  isSubmitting: boolean
  // Is the form valid as a whole
  isFormValid: boolean
  // When the validity of a question is changed - decided by the question itself
  onFieldValidityChanged: (name: string, valid: boolean) => void
  // When the value of a question is changed - decided by the question itself
  onFieldValueChanged: (
    name: string,
    value: FormValueObject,
    callback?: (() => void) | undefined
  ) => void
  // On the page (form) submitted
  onPageSubmitted: () => void
  // On the page (form) backward navigation
  onPageBack: () => void
}

const PathContext = React.createContext<PathContextType | undefined>(undefined)

const PathContextProvider = PathContext.Provider
const PathContextConsumer = PathContext.Consumer

const usePathContext = () => {
  const pathContext = useContext(PathContext)

  if (!pathContext) {
    throw new Error('Invoked path context without intital values')
  }

  return pathContext
}

export { usePathContext, PathContext, PathContextConsumer, PathContextProvider }
